import { Injectable } from "@angular/core";
import type { Resolve } from '@angular/router';
import { ReleaseNoteAuthorFacade } from '@medsurf/flat-facades';

@Injectable({
  providedIn: "root"
})
export class ReleaseNoteAuthorResolver implements Resolve<void> {
  constructor(protected releaseNoteAuthorFacade: ReleaseNoteAuthorFacade) {
  }

  resolve() {
    return this.releaseNoteAuthorFacade.requestGetReleaseNotes();
  }
}